import { Injectable } from '@angular/core';

import { TRACKING_DEFAULT } from '../../../shared/defines/tracking.defines';
import { TrackingService } from '@vfde-fe/ngx-lib/plugins/tracking';
import { PageTracking } from '@vfde-fe/ngx-lib/plugins/tracking';

/**
 * TrackingHandlerService is service to handle app tracking
 */
@Injectable()
export class TrackingHandlerService {

  public constructor (
    private trackingService: TrackingService,
  ) { }

  /**
   * trackPageView
   * @description trackPageView is a method which track page view
   * @param siteStructure
   * @returns void
   */
  public trackPageView (siteStructure: string[]): void {
    const { siteArea, pageType, loginStatus, platformType } = TRACKING_DEFAULT;
    siteStructure = [...siteStructure];
    const pageTracking: PageTracking = { loginStatus, siteStructure, pageType, platformType, siteArea };
    this.trackingService.trackPageView(pageTracking);
  }

}
